import { createAdConfig } from '@/utils/adUtil'

export const appRadarAdConfig = {}

appRadarAdConfig.AD_SIZES = {
  SP_ATF: [
    [320, 50]
  ],
  STICKY: [320, 50]
}

appRadarAdConfig.gpt_conf = [
  createAdConfig('Onebox_world_atf_sp', appRadarAdConfig.AD_SIZES.SP_ATF, 'ads-atf', 'DATA', false, 'sp'),
  createAdConfig('Onebox_sticky_ad', appRadarAdConfig.AD_SIZES.STICKY, 'div-gpt-ad-sticky', 'DATA', true, 'sp', true)
]
